export const UserTypes = {
  ADMIN: "admin",
  DESIGNER: "designer",
  CREW_SUPERVISOR: "crew_supervisor",
  CREW_LEADER: "crew_leader"
};

export const UserTypeLabels = {
  [UserTypes.ADMIN]: "Admin",
  [UserTypes.DESIGNER]: "Designer",
  [UserTypes.CREW_SUPERVISOR]: "Crew Supervisor",
  [UserTypes.CREW_LEADER]: "Crew Leader"
};
